<template>
    <div class="">
        <new-modal
            :title="'Add Students to &ldquo;' + classroom.name + '&rdquo;'"
            size="5xl"
            ref="addStudentModal"
        >
            <template #trigger>
                <div class="btn btn-primary">+ Add Student</div>
            </template>
            <template #content>
                <div class="mb-4 w-[300px]">
                    <div
                        class="box-content flex h-10 items-center rounded border border-gray-350 text-center text-[15px]"
                    >
                        <div
                            @click="showForm = 'newStudent'"
                            :class="
                                'flex h-10 flex-grow items-center justify-center border-r border-gray-350 px-4 py-2 hover:cursor-pointer hover:bg-gray-250' +
                                ' ' +
                                (showForm === 'newStudent'
                                    ? 'bg-gray-250 font-medium'
                                    : 'bg-white text-gray-650')
                            "
                        >
                            New Student
                        </div>
                        <div
                            @click="showForm = 'existingStudents'"
                            :class="
                                'flex h-10 flex-grow items-center justify-center border-r border-gray-350 px-4 py-2 hover:cursor-pointer hover:bg-gray-250' +
                                ' ' +
                                (showForm === 'existingStudents'
                                    ? 'bg-gray-250 font-medium'
                                    : 'bg-white text-gray-650')
                            "
                        >
                            Existing students
                        </div>
                    </div>
                </div>

                <GroupInviteNewStudentForm
                    v-if="showForm === 'newStudent'"
                    :force-classroom-id="classroom.id"
                    v-on:cancel="closeModal"
                />

                <GroupClassroomAddExistingStudentsForm
                    v-if="showForm === 'existingStudents'"
                    :classroom="classroom"
                    v-on:cancel="closeModal"
                />
            </template>
        </new-modal>
    </div>
</template>
<script>
import NewModal from "@/Components/NewModal";
import GroupInviteNewStudentForm from "@/Components/GroupInviteNewStudentForm";
import GroupClassroomAddExistingStudentsForm from "@/Components/GroupClassroomAddExistingStudentsForm";

export default {
    name: "GroupClassroomAddStudentModal",
    components: {
        GroupClassroomAddExistingStudentsForm,
        GroupInviteNewStudentForm,
        NewModal,
    },
    props: {
        classroom: {},
    },
    data() {
        return {
            showForm: "newStudent",
        };
    },
    methods: {
        closeModal() {
            this.$refs.addStudentModal.closeModal();
        },
    },
};
</script>
